module.exports = __webpack_public_path__ + "img/fortnox-integrationspartner2.92f167c3.png";